import PropTypes from 'prop-types';
import { ChevronRightSvg } from "../../assets/svgs";
import { Container, TopRow, IconBox, Title, ValueRow, ThirdRow, ThirdRowValue } from './dashboard-card-secondary.style';

const DashboardCardSecondary = ({
    title,
    labelPrimary,
    valuePrimary,
    valueSecondary,
    variant = "default",
    iconSecondary: Icon = ChevronRightSvg,
}) => {

    const resolvedLabelSecondary = (() => {
        switch (variant) {
            case 'pending':
                return 'Avg. Processing Time';
            case 'success':
                return 'Success Rate';
            default:
                return 'Success Rate';
        }
    })();

    return (
        <Container className="box-shadow">
            <TopRow>
                <IconBox $variant={variant}>
                    <Icon />
                </IconBox>
                <Title>{title}</Title>
            </TopRow>
            <ValueRow>
                <p>{labelPrimary}</p>
                <h2>{valuePrimary}</h2>
            </ValueRow>
            <ThirdRow>
                <p>{resolvedLabelSecondary}</p>
                {
                    (valueSecondary !== undefined && valueSecondary !== 0 && valueSecondary !== 0.00) ? (
                        <ThirdRowValue $variant={variant}>{valueSecondary + (variant === 'pending' ? '' : '%')}</ThirdRowValue>
                    ) : (
                        <p>0%</p>
                    )
                }
            </ThirdRow>
        </Container>
    );
}

DashboardCardSecondary.propTypes = {
    title: PropTypes.string.isRequired,
    labelPrimary: PropTypes.string.isRequired,
    valuePrimary: PropTypes.number.isRequired,
    valueSecondary: PropTypes.any,
    variant: PropTypes.oneOf(['default', 'success', 'pending']),
    iconSecondary: PropTypes.elementType
};

export default DashboardCardSecondary;